import React, {useEffect} from 'react';

import {RasterService} from '../../utils/RasterService';


const MapRasters = ({Map, layerConfig}) => {
    let layer = null; 

    const initRaster = (async function(config) {
        if (!config.url) return;
        let pixelValuesToColorFn = config.pixelValuesToColorFn;
    
        const raster = await RasterService.createRaster(config.url, pixelValuesToColorFn, {
          resolution: config.resolution,
          opacity: config.opacity
        });
        raster.setZIndex(config.zIndex);
        raster.addTo(Map);
        layer = raster
      });

    useEffect(() => {

        if (!Map) return;

        initRaster(layerConfig)

        return function cleanup() {
            if (layer) layer.remove();
        }   

    }, [Map])

    return null;
}

export default MapRasters;